// Wie setzt sich die Palettenmenge zusammen? WE rechnet Menge = Kartons × Stück/Karton + Rest-Stück
// (computeWeMenge). Verschlossen: erfasste Werte gegen die Etikettmenge; angebrochen/unterwegs:
// Restkartons aus der aktuellen Menge, erfasste Kartons nur als Herkunft. Verschlossen ohne erfasste
// Kartons (Erstaufnahme / alter WE speichern nur Menge + Stück je Karton): aus der Menge gerechnet.
import type { ArtikelPosition } from '@/api/warehouse'

export interface KartonAufschluesselung {
  kartons: number
  proKarton: number
  rest: number
  /** false = Kartons × Inhalt + Rest weicht von der Etikettmenge ab */
  passt: boolean
  /** erfasste Kartons beim Einlagern, nur bei nicht verschlossenen Paletten */
  erfasst: number | null
  /** true = keine Kartonzahl erfasst, Kartons aus Menge ÷ Stück je Karton gerechnet */
  gerechnet: boolean
  /** 1 Stück je Karton: Ware liegt einzeln, „N Kartons à 1 St.“ wäre irreführend */
  einzeln: boolean
}

type Pos = Pick<ArtikelPosition, 'state' | 'qtyExact' | 'qtyCirca' | 'cartons' | 'piecesPerCarton' | 'restPieces'>

export function kartonAufschluesselung(p: Pos): KartonAufschluesselung | null {
  const pro = p.piecesPerCarton
  if (pro === null || pro <= 0) return null
  const einzeln = pro === 1
  if (p.state === 'verschlossen') {
    if (p.cartons === null) {
      if (p.qtyExact === null) return null
      return { kartons: Math.floor(p.qtyExact / pro), proKarton: pro, rest: p.qtyExact % pro, passt: true, erfasst: null,
        gerechnet: true, einzeln }
    }
    const rest = p.restPieces ?? 0
    return { kartons: p.cartons, proKarton: pro, rest, erfasst: null,
      passt: p.qtyExact === null || p.cartons * pro + rest === p.qtyExact, gerechnet: false, einzeln }
  }
  if (p.qtyCirca === null) return null
  return { kartons: Math.floor(p.qtyCirca / pro), proKarton: pro, rest: p.qtyCirca % pro, passt: true, erfasst: p.cartons,
    gerechnet: false, einzeln }
}

export function kartonWort(n: number): string {
  return `${n} ${n === 1 ? 'Karton' : 'Kartons'}`
}

export function kartonText(a: KartonAufschluesselung): string {
  if (a.einzeln) return 'einzeln'
  return `${kartonWort(a.kartons)} à ${a.proKarton} St.${a.rest > 0 ? ` + ${a.rest} St.` : ''}`
}
